
import { RevLink } from '@ds/components/Link'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { tw } from '@core/tailwind'

import {
  PaymentIcons,
  PaymentMethodsErrors,
  isPaymentMethodEnabled,
} from '../../methods'
import { PAYMENT_ADVERTISING_TYPES } from '../config/constants'
import {
  getAdvertisingOptionsFromComponent,
  paymentAdvertising,
} from '../helpers/advertising'

import translations from './PaymentAdvertisement.translations'

export default {
  components: {
    PaymentMethodsErrors,
    PaymentIcons,
    RevLink,
  },

  props: {
    basePrice: {
      type: Object,
      default: null,
    },

    paymentMethods: {
      type: Array,
      default: null,
    },

    tag: {
      type: String,
      default: 'div',
    },

    textSize: {
      type: String,
      default: '2',
      validator: (value) => ['1', '2'].includes(value),
    },

    type: {
      type: String,
      required: true,
      validator: (value) =>
        Object.values(PAYMENT_ADVERTISING_TYPES).includes(value),
    },

    iconClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      countryPaymentMethods: 'countryConfig/paymentMethods',
    }),

    classes() {
      const classesByTextSize = {
        1: {
          typography: tw`body-1-light`,
          gap: tw`gap-x-2`,
        },
        2: {
          typography: tw`body-2-light`,
          gap: tw`gap-x-1`,
        },
      }

      const classesByAvailability = {
        true: {
          color: tw`text-primary`,
          saturate: '',
        },
        false: {
          color: tw`tw-text-primary-disabled`,
          saturate: tw`saturate-0`,
        },
      }

      return {
        ...classesByAvailability[this.isAvailable],
        ...classesByTextSize[this.textSize],
      }
    },

    hasErrors() {
      return !isEmpty(this.advertisement?.method?.errors)
    },

    hasModal() {
      return !isEmpty(this.advertisement?.modal) && this.isAvailable
    },

    isAdvertised() {
      return this.advertisement !== null
    },

    isAvailable() {
      return isPaymentMethodEnabled(this.advertisement.method)
    },

    advertisement() {
      return paymentAdvertising(this.type, this.paymentMethodsWithFallback, {
        ...getAdvertisingOptionsFromComponent(this),
        includeDisabledMethods: this.type === PAYMENT_ADVERTISING_TYPES.CART,
      })
    },

    advertisementDetails() {
      if (this.advertisement === null) {
        return {}
      }

      if (this.type === PAYMENT_ADVERTISING_TYPES.CART) {
        return this.isAvailable
          ? { linkText: this.$t(this.advertisement.available) }
          : { plainText: this.$t(this.advertisement.unavailable) }
      }

      return {
        linkText: this.$t(translations.learnMore),
        plainText: this.$t(this.advertisement.label),
      }
    },

    paymentMethodsWithFallback() {
      return this.paymentMethods ?? this.countryPaymentMethods
    },
  },

  methods: {
    openAndEmitEvent(open) {
      open()
      this.$emit('open', this.advertisement)
    },
  },
}
